import UikTrend from "./Trend"
import UikData from "./Data"
import UikDataWidget from "./DataWidget"
import UikDataLabel from "./DataLabel"
import UikProgress from "./Progress"
import UikProgressBars from "./ProgressBars"
import UikBars from "./Bars"
import UikShares from "./Shares"
import UikHighlightCard from "./HighlightCard"
import UikIndicator from "./Indicator"

export default [
    UikTrend,
    UikData,
    UikDataWidget,
    UikDataLabel,
    UikProgress,
    UikProgressBars,
    UikBars,
    UikShares,
    UikHighlightCard,
    UikIndicator
]
